import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: theme => ({
    borderBottomColor: theme.colors.borderColorThree,
    borderBottomWidth: 1,
    paddingBottom: 17,
    marginBottom: 16,
  }),
  statusContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 17,
  },
  statusTextStyle: {
    ...Fonts.type.bold,
    fontSize: 16.6,
    lineHeight: 22.9,
  },
  activeStatusTextStyle: {
    color: Colors.secondary5,
  },
  inActiveStatusTextStyle: {
    color: Colors.tangerine,
  },
  renewalDateTextStyle: theme => ({
    fontSize: 16.6,
    lineHeight: 22.9,
    color: theme.colors.inActiveColorThree,
  }),
  nameTextStyle: {
    fontSize: 25,
    lineHeight: 31.2,
    fontFamily: Fonts.type.VodafoneLt,
  },
  iconAndTextContainerStyle: { flexDirection: 'row' },
  iconStyle: { marginLeft: 10, marginTop: 2 },
});
